<template>
  <div :id="id" class="modal" tabindex="-1" role="dialog">
    <div
      :class="[
        'modal-dialog',
        size == 'sm'
          ? 'modal-sm'
          : size == 'sm2'
          ? 'modal-sm2'
          : size == 'md'
          ? 'modal-md'
          : size == 'md2'
          ? 'modal-md2'
          : size == 'md3'
          ? 'modal-md3'
          : size == 'lg'
          ? 'modal-lg'
          : ''
      ]"
      role="document"
    >
      <div
        :class="{
          'modal-content': true
        }"
        :style="{ 'margin-top': margintop ? margintop : '25%' }"
      >
        <div class="modal-header">
          <b>{{ title }}</b>
          <button
            type="button"
            class="close"
            aria-label="Close"
            @click="localEventHandler('close')"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div
          :class="{
            'modal-body': true,
            'modal-body-y-scroll': showBodyYScroll
          }"
          :style="{ 'max-height': bodyMaxHeight ? bodyMaxHeight : 'auto' }"
        >
          <div class="mx-3 mt-3">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    'id',
    'title',
    'size',
    'margintop',
    'showBodyYScroll',
    'bodyMaxHeight'
  ],
  methods: {
    localEventHandler (name, event) {
      if (name == 'close') {
        $('#' + this.id).modal('hide')
      }
    }
  }
}
</script>

<style scoped>
/* The Modal (background) */
.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: inf; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow-y: none !important; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
  padding-right: 0px !important;
}

.modal-sm2 {
  max-width: 350px !important;
}

.modal-md {
  max-width: 500px !important;
}

.modal-md2 {
  max-width: 550px !important;
}
.modal-md3 {
  max-width: 600px !important;
}
.modal-md4 {
  max-width: 650px !important;
}

/* .modal-dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) !important;
} */
.modal-content {
  background-color: #fefefe;
  margin-left: auto;
  margin-right: auto;
  border: 0px;
}
.modal-body-y-scroll {
  overflow-y: scroll !important;
}

.modal-open {
  overflow: none !important;
  width: 100%;
  height: 100%;
  position: fixed;
  padding-right: 0px !important;
}
</style>
